import React from "react";
import controls from "modules/controls";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Tooltip from "components/Tooltip/Tooltip";

import "./ControlsButton.css";

class ControlsButton extends React.Component {
  constructor() {
    super();
    this.state = {
      labelClass: ""
    };
  }

  checkControlButton(label) {
    this.props.checkControl(label);

    this.setState(state => ({
      labelClass: state.labelClass === "active" ? "" : "active"
    }));
  }

  render() {
    const { btn, style } = this.props;

    return (
      <button
        style={style}
        className={`group-controls-col-button ${this.state.labelClass}`}
        onClick={() => this.checkControlButton(btn.id)}
      >
        {btn.text}
        {btn.explanation ? <Tooltip explanation={btn.explanation} /> : null}
      </button>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  checkControl: bindActionCreators(controls.actions.checkControl, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(ControlsButton);



// WEBPACK FOOTER //
// ./src/components/ControlsButton/index.js